"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _background = _interopRequireDefault(require("../images/haglofs/background.jpg"));

var _logo = _interopRequireDefault(require("../images/haglofs/logo.svg"));

var _stitches = require("../stitches.config");

var images = {
  brandLogo: _logo.default
};
var theme = (0, _stitches.createTheme)('haglofs', {
  background: {
    image: "url(".concat(_background.default, ")"),
    position: 'top center',
    mobile: "url(".concat(_background.default, ")")
  },
  buttonShape: {
    default: '$square'
  },
  colors: {
    inputBorder: '$grey600',
    inputBorderFocused: '$black',
    inputText: '$grey700',
    primary: '#ff4338',
    primaryHover: '$primary',
    textPrimary: '#041e41'
  },
  fonts: {
    globalFont: 'GT-Eesti, Graphik, arial, sans-serif'
  },
  fontWeights: {
    regular: 300,
    medium: 400,
    semiBold: 500
  }
});
var _default = {
  images: images,
  theme: theme
};
exports.default = _default;